import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add Authorization header from localStorage as fallback to cookies
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hg_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function fileUrl(path) {
  if (!path) return null;
  // Demo seed images use a special prefix to return external URLs as-is
  if (path.startsWith("__seed:")) return path.slice(7);
  if (path.startsWith("http")) return path;
  const token = localStorage.getItem("hg_token");
  const q = token ? `?auth=${encodeURIComponent(token)}` : "";
  return `${API}/files/${path}${q}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
